import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {APP_INITIALIZER, ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter} from '@angular/router';
import {ClinicService} from '@infrastructure/admin/clinics/clinic.service';
import {AgendaService} from '@infrastructure/clinician/agenda/agenda.service';
import {ClinicianService} from '@infrastructure/clinician/clinician.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {provideAngularSvgIcon} from 'angular-svg-icon';
import {routes} from './app.routes';
import {appInitializerFactory} from './core/app-initializer.factory';
import {AdminService} from './infrastructure/admin/admin.service';
import {GenericAuthService} from './infrastructure/generic-auth/generic-auth.service';
import {interceptor} from './infrastructure/interceptor';
import {OwnerService} from './infrastructure/owner/owner.service';

const createTranslateLoader = (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideAnimationsAsync(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([interceptor])),
        provideAngularSvgIcon(),
        importProvidersFrom([TranslateModule.forRoot({
            loader:
            {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        })]),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            multi: true,
            deps: [GenericAuthService, OwnerService, AdminService, ClinicianService, ClinicService, AgendaService]
        }
    ]
};
